import { render, staticRenderFns } from "./AccessoryDetails.vue?vue&type=template&id=be936d80&scoped=true&"
import script from "./AccessoryDetails.vue?vue&type=script&lang=js&"
export * from "./AccessoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryDetails.vue?vue&type=style&index=0&id=be936d80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be936d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardTitle,VCol,VIcon,VSelect,VSwitch,VTooltip})
